import React from 'react'

import ValueText, { ValueTextProps } from 'components_new/molecules/ValueText'

import { getDiff, getPercentageChange, getSeverity } from './utils'
import { formatValue } from 'components_new/organisms/Widget/Types/utils'
import { AUTO_SIGNIFICANT_FIGURES, getAutoScale } from 'utils/autoFormat'

interface ChangeTextProps extends Omit<ValueTextProps, 'value'> {
  denominator: number | null // bottom, first
  error?: string
  increaseIsPositive: boolean
  numerator: number | null // top, last
}

const ChangeText = React.forwardRef((props: ChangeTextProps, ref: any) => {
  const {
    denominator,
    error,
    increaseIsPositive,
    numerator,
    unit,
    unitPrefixes,
    ...rest
  } = props

  const diff = getDiff({ firstValue: denominator, lastValue: numerator })

  const severity = getSeverity({
    firstValue: denominator,
    increaseIsPositive: increaseIsPositive,
    lastValue: numerator
  })

  const percentChange = getPercentageChange({
    firstValue: denominator,
    lastValue: numerator
  })

  const { unitPrefix, unitLabel } = getAutoScale([diff], unit, unitPrefixes)
  const formattedDiff = formatValue(
    diff,
    unitPrefix,
    1,
    true,
    undefined,
    AUTO_SIGNIFICANT_FIGURES
  )

  const getColor = () => {
    if (error) {
      return 'warning.text'
    }

    switch (severity) {
    case 'error':
      return 'error.text'
    case 'success':
      return 'success.text'
    default:
      return 'text.disabled'
    }
  }

  const getTooltipTitle = () => {
    if (error) {
      return undefined
    }

    return (
      <>
        {diff && diff > 0 ? '+' : ''}
        {formattedDiff} {unit === '%' ? 'p.e.' : unitLabel}
      </>
    )
  }

  return (
    <ValueText
      color={getColor()}
      displayPositiveIndicator={true}
      error={error}
      ref={ref}
      tooltip={getTooltipTitle()}
      unit="%"
      value={percentChange}
      {...rest}
    />
  )
})

ChangeText.displayName = 'ChangeText'

export default ChangeText
